import { ScaleEnum } from "@/types";
const createScaleRecord = ({ color, width, verticalPosition, d, previewTextColor = "color.content.constant.black", fullsizeTextColor = "color.content.constant.black", }) => ({
    color,
    width,
    verticalPosition,
    d,
    previewTextColor,
    fullsizeTextColor,
});
const deResidentialScaleConfig = [
    {
        color: "color.scales.energy.green200",
        width: 52,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h40.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 42.93 0H2Z",
        fullsizeTextColor: "color.content.constant.white",
    },
    {
        color: "color.scales.energy.green300",
        width: 64,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h52.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 54.93 0H2Z",
    },
    {
        color: "color.scales.energy.green400",
        width: 76,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h64.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 66.93 0H2Z",
    },
    {
        color: "color.scales.energy.yellow100",
        width: 88,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h76.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 78.93 0H2Z",
    },
    {
        color: "color.scales.energy.yellow200",
        width: 100,
        verticalPosition: { top: "-50px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h88.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 90.93 0H2Z",
    },
    {
        color: "color.scales.energy.orange100",
        width: 112,
        verticalPosition: { top: "-50px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h100.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 102.93 0H2Z",
    },
    {
        color: "color.scales.energy.orange200",
        width: 124,
        verticalPosition: { bottom: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h112.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 114.93 0H2Z",
    },
    {
        color: "color.scales.energy.red100",
        width: 136,
        verticalPosition: { bottom: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h124.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 126.93 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
    {
        color: "color.scales.energy.red200",
        width: 148,
        verticalPosition: { bottom: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h136.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 138.93 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
];
const DE_RESIDENTIAL_SCALE = deResidentialScaleConfig.reduce((acc, config, index) => {
    acc[index] = createScaleRecord(config);
    return acc;
}, {});
const deCommercialScaleConfig = [
    {
        color: "color.scales.energy.green100",
        width: 52,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h40.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 42.93 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
    {
        color: "color.scales.energy.green200",
        width: 64,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h52.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 54.93 0H2Z",
    },
    {
        color: "color.scales.energy.green300",
        width: 76,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h64.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 66.93 0H2Z",
    },
    {
        color: "color.scales.energy.green400",
        width: 88,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h76.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 78.93 0H2Z",
    },
    {
        color: "color.scales.energy.yellow100",
        width: 100,
        verticalPosition: { top: "-50px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h88.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 90.93 0H2Z",
    },
    {
        color: "color.scales.energy.yellow200",
        width: 112,
        verticalPosition: { top: "-50px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h100.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 102.93 0H2Z",
    },
    {
        color: "color.scales.energy.orange100",
        width: 124,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h112.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 114.93 0H2Z",
    },
    {
        color: "color.scales.energy.orange200",
        width: 136,
        verticalPosition: { top: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h124.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 126.93 0H2Z",
    },
    {
        color: "color.scales.energy.red100",
        width: 148,
        verticalPosition: { bottom: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h136.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 138.93 0H2Z",
    },
    {
        color: "color.scales.energy.red200",
        width: 160,
        verticalPosition: { bottom: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h148.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 150.93 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
    {
        color: "color.scales.energy.red300",
        width: 172,
        verticalPosition: { bottom: "0px" },
        d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h160.93a2 2 0 0 0 1.664-.89l6.666-10a2 2 0 0 0 0-2.22l-6.666-10A2 2 0 0 0 162.93 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
];
const DE_COMMERCIAL_SCALE = deCommercialScaleConfig.reduce((acc, config, index) => {
    acc[index] = createScaleRecord(config);
    return acc;
}, {});
const frEnergyScaleConfig = [
    {
        color: "color.scales.energy.green100",
        width: 64,
        verticalPosition: { top: "0px" },
        d: "M2 0C0.89543 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H54.9296C55.5983 24 56.2228 23.6658 56.5937 23.1094L63.2604 13.1094C63.7083 12.4376 63.7083 11.5624 63.2604 10.8906L56.5937 0.890599C56.2228 0.334202 55.5983 0 54.9296 0H2Z",
    },
    {
        color: "color.scales.energy.green200",
        width: 76,
        verticalPosition: { top: "0px" },
        d: "M2 0C0.895432 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H66.9296C67.5983 24 68.2228 23.6658 68.5937 23.1094L75.2604 13.1094C75.7083 12.4376 75.7083 11.5624 75.2604 10.8906L68.5937 0.890599C68.2228 0.334202 67.5983 0 66.9296 0H2Z",
    },
    {
        color: "color.scales.energy.green400",
        width: 88,
        verticalPosition: { top: "-50px" },
        d: "M2 0C0.895429 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H78.9296C79.5983 24 80.2228 23.6658 80.5937 23.1094L87.2604 13.1094C87.7083 12.4376 87.7083 11.5624 87.2604 10.8906L80.5937 0.890599C80.2228 0.334202 79.5983 0 78.9296 0H2Z",
    },
    {
        color: "color.scales.energy.yellow100",
        width: 100,
        verticalPosition: { top: "-50px" },
        d: "M2 0C0.89543 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H90.9296C91.5983 24 92.2228 23.6658 92.5937 23.1094L99.2604 13.1094C99.7083 12.4376 99.7083 11.5624 99.2604 10.8906L92.5937 0.890599C92.2228 0.334202 91.5983 0 90.9296 0L2 0Z",
    },
    {
        color: "color.scales.energy.orange200",
        width: 112,
        verticalPosition: { top: "-110px" },
        d: "M2 0C0.895432 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H102.93C103.598 24 104.223 23.6658 104.594 23.1094L111.26 13.1094C111.708 12.4376 111.708 11.5624 111.26 10.8906L104.594 0.890599C104.223 0.334202 103.598 0 102.93 0H2Z",
    },
    {
        color: "color.scales.energy.red100",
        width: 124,
        verticalPosition: { bottom: "0px" },
        d: "M2 0C0.895428 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H114.93C115.598 24 116.223 23.6658 116.594 23.1094L123.26 13.1094C123.708 12.4376 123.708 11.5624 123.26 10.8906L116.594 0.890599C116.223 0.334202 115.598 0 114.93 0H2Z",
        previewTextColor: "color.content.constant.white",
    },
    {
        color: "color.scales.energy.red200",
        width: 136,
        verticalPosition: { bottom: "0px" },
        d: "M2 0C0.895431 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H126.93C127.598 24 128.223 23.6658 128.594 23.1094L135.26 13.1094C135.708 12.4376 135.708 11.5624 135.26 10.8906L128.594 0.890599C128.223 0.334202 127.598 0 126.93 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
];
const FR_ENERGY_SCALE = frEnergyScaleConfig.reduce((acc, config, index) => {
    acc[index] = createScaleRecord(config);
    return acc;
}, {});
const frGhgBefore2021ScaleConfig = [
    {
        color: "#F4ECF4",
        width: 64,
        verticalPosition: { top: "0px" },
        d: "M0 0V24H64V12V0H0Z",
    },
    {
        color: "#D4C0DA",
        width: 76,
        verticalPosition: { top: "0px" },
        d: "M0 0V24H76V12V0H0Z",
    },
    {
        color: "#C2AACA",
        width: 88,
        verticalPosition: { top: "-50px" },
        d: "M0 0V24H88V12V0H0Z",
    },
    {
        color: "#B396C0",
        width: 100,
        verticalPosition: { top: "-50px" },
        d: "M0 0V24H100V12V0L0 0Z",
        previewTextColor: "color.content.constant.white",
    },
    {
        color: "#9877A9",
        width: 112,
        verticalPosition: { top: "-110px" },
        d: "M0 0V24H112V12V0H0Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
    {
        color: "#7B5897",
        width: 124,
        verticalPosition: { bottom: "0px" },
        d: "M0 0V24H124V12V0H0Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
    {
        color: "#66438C",
        width: 136,
        verticalPosition: { bottom: "0px" },
        d: "M0 0V24H136V12V0H0Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
];
const FR_GHG_BEFORE_2021_SCALE = frGhgBefore2021ScaleConfig.reduce((acc, config, index) => {
    acc[index] = createScaleRecord(config);
    return acc;
}, {});
const frGhgAfter2021ScaleConfig = [
    {
        color: "color.scales.co2.blue100",
        width: 64,
        verticalPosition: { top: "0px" },
        d: "M1.23077 0C0.551035 0 0 0.551034 0 1.23077V22.7692C0 23.449 0.551034 24 1.23077 24H52C58.6274 24 64 18.6274 64 12C64 5.37258 58.6274 0 52 0H1.23077Z",
    },
    {
        color: "color.scales.co2.blue200",
        width: 76,
        verticalPosition: { top: "0px" },
        d: "M1.4902 0C0.667183 0 0 0.667184 0 1.4902V22.5098C0 23.3328 0.667184 24 1.4902 24H64C70.6274 24 76 18.6274 76 12C76 5.37258 70.6274 0 64 0H1.4902Z",
    },
    {
        color: "color.scales.co2.blue300",
        width: 88,
        verticalPosition: { top: "-50px" },
        d: "M1.72548 0C0.772523 0 0 0.772528 0 1.72549V22.2745C0 23.2275 0.772528 24 1.72549 24H76C82.6274 24 88 18.6274 88 12C88 5.37258 82.6274 0 76 0H1.72548Z",
    },
    {
        color: "color.scales.co2.blue400",
        width: 100,
        verticalPosition: { top: "-50px" },
        d: "M1.96078 0C0.877873 0 0 0.877873 0 1.96078V22.0392C0 23.1221 0.877873 24 1.96078 24H88C94.6274 24 100 18.6274 100 12C100 5.37258 94.6274 0 88 0L1.96078 0Z",
        previewTextColor: "color.content.constant.white",
    },
    {
        color: "color.scales.co2.blue500",
        width: 112,
        verticalPosition: { top: "-110px" },
        d: "M2 0C0.89543 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H100C106.627 24 112 18.6274 112 12C112 5.37258 106.627 0 100 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
    {
        color: "color.scales.co2.blue600",
        width: 124,
        verticalPosition: { bottom: "0px" },
        d: "M2 0C0.895429 0 0 0.895431 0 2V22C0 23.1046 0.89543 24 2 24H112C118.627 24 124 18.6274 124 12C124 5.37258 118.627 0 112 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
    {
        color: "color.scales.co2.blue700",
        width: 136,
        verticalPosition: { bottom: "0px" },
        d: "M2 0C0.895432 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H124C130.627 24 136 18.6274 136 12C136 5.37258 130.627 0 124 0H2Z",
        previewTextColor: "color.content.constant.white",
        fullsizeTextColor: "color.content.constant.white",
    },
];
const FR_GHG_AFTER_2021_SCALE = frGhgAfter2021ScaleConfig.reduce((acc, config, index) => {
    acc[index] = createScaleRecord(config);
    return acc;
}, {});
export const scaleRecordMap = {
    [ScaleEnum.DE_COMMERCIAL]: DE_COMMERCIAL_SCALE,
    [ScaleEnum.DE_RESIDENTIAL]: DE_RESIDENTIAL_SCALE,
    [ScaleEnum.AT]: DE_RESIDENTIAL_SCALE,
    [ScaleEnum.FR_ENERGY_BEFORE_2021]: FR_ENERGY_SCALE,
    [ScaleEnum.FR_ENERGY_AFTER_2021]: FR_ENERGY_SCALE,
    [ScaleEnum.FR_GHG_BEFORE_2021]: FR_GHG_BEFORE_2021_SCALE,
    [ScaleEnum.FR_GHG_AFTER_2021]: FR_GHG_AFTER_2021_SCALE,
};
export const isGasScale = (type) => type === ScaleEnum.FR_GHG_BEFORE_2021 || type === ScaleEnum.FR_GHG_AFTER_2021;
